import { render, staticRenderFns } from "./SASBTable.vue?vue&type=template&id=59c2a0e8&scoped=true"
import script from "./SASBTable.vue?vue&type=script&lang=js"
export * from "./SASBTable.vue?vue&type=script&lang=js"
import style0 from "./SASBTable.vue?vue&type=style&index=0&id=59c2a0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2a0e8",
  null
  
)

export default component.exports